<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-sm-6 ml-auto mr-auto">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left p-0 m-0">Abonos</h4>
          <div class="row m-0 p-0">
            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Data Inicial"
                type="date"
                placeholder="Data Inicial"
                v-model="abono.data_inicial"
                :class="erros.data_inicial === true ? 'has-danger' : ''"
              >
              </base-input>
            </div>

            <div class="col-md-6 p-2 text-left">
              <base-input
                label="Data Final"
                type="date"
                placeholder="Data Final"
                v-model="abono.data_final"
                :class="erros.data_final === true ? 'has-danger' : ''"
              >
              </base-input>
            </div>

            <div class="col-md-12 p-2 text-left">
              <base-input
                label="Qtde. de horas a abonar"
                type="tel"
                v-mask="'##:##'"
                placeholder="##:##"
                v-model="abono.hora"
                :class="erros.hora === true ? 'has-danger' : ''"
              >
              </base-input>
            </div>
          </div>

          <div class="row m-0 p-0 text-left">
            <div class="col-sm-12 p-2">
              <label>Tipo Abono</label>
              <el-select
                class="select-primary w-100"
                size="large"
                placeholder="Selecionar Abono"
                v-model="abono.tipo"
                :class="erros.tipo === true ? 'has-danger' : ''"
              >
                <el-option
                  v-for="option in listAbonos"
                  class="select-primary"
                  :value="option.id"
                  :label="option.descricao"
                  :key="option.descricao"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row m-0 p-0 text-left" v-if="matriculas.length > 1">
            <div class="col-sm-12 p-2">
              <label>Matrícula</label>
              <el-select
                label="Matrícula"
                class="select-primary w-100"
                size="large"
                placeholder="Selecionar Matricula"
                v-model="abono.matricula"
                :class="erros.tipo === true ? 'has-danger' : ''"
              >
                <el-option
                  v-for="option in matriculas"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="row m-0 p-0 justify-content-center">
            <div class="col-md-12 p-2">
              <h4
                class="card-title"
                :class="erros.file === true ? 'text-danger' : ''"
              >
                Arquivo
              </h4>
              <image-upload
                @change="onImageChange"
                select-text="Selecione o arquivo"
                :formatos-validos="[
                  'image/jpeg',
                  'image/png',
                  'application/pdf',
                ]"
              />
            </div>
            <div class=" alert-box ">
              <strong>
                <i class="fas fa-exclamation-triangle icon_alert"></i>Atenção:
                Critérios para envio de Arquivo</strong
              >
              <ul>
                <li>
                  <strong>Formatos de Arquivo Aceitos:</strong> JPG ,PNG e PDF
                </li>
                <li>
                  <strong
                    >Imagens permitidas com tamanho máximo de 2 MB e PDFs com
                    limite de 1 MB.</strong
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-md-12 p-2">
              <base-button
                @click="enviarAbono()"
                native-type="submit"
                type="success"
                class="mb-3"
                size="lg"
                block
              >
                Enviar Abono
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BasePagination,
  BaseInput,
  ImageUpload,
} from "@/components/index";
import {
  Table,
  TableColumn,
  Select,
  Option,
  TimeSelect,
  DatePicker,
} from "element-ui";
import users from "../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    ImageUpload,

    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      matriculas: [],
      abono: {
        data_inicial: "",
        data_final: "",
        hora: "",
        tipo: "",
        file: null,
        matricula: null,
      },
      listAbonos: [],
      horarioSelecionado: "",
      cadAlt: "",
      descricao: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
      erros: {
        data_inicial: "",
        data_final: "",
        hora: "",
        tipo: "",
        file: "",
      },
      dados: "",
    };
  },
  created() {
    this.carregarDados();
  },
  mounted() {
    this.listarAbono();
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3,
    });
  },
  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));

      if (this.dados.matricula) {
        this.matriculas.push(this.dados.matricula);
      }
      if (this.dados.matricula2) {
        this.matriculas.push(this.dados.matricula2);
      }

      // deixa pre selecionada
      if (this.matriculas.length == 1) {
        this.abono.matricula = this.matriculas[0];
      }
    },

    onImageChange(file) {
      if (!file) return;
      //console.log("Tipo de arquivo:", file.type);
      // https://stackoverflow.com/questions/6150289/how-can-i-convert-an-image-into-base64-string-using-javascript
      var reader = new FileReader();
      let th = this;
      reader.onloadend = function() {
        th.abono.file = reader.result;
      };
      reader.readAsDataURL(file);
    },

    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    moment: function(data) {
      return moment(data);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarAbono() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.dados.DB_NAME,
        ativo: "S",
      };
      this.axios
        .post("/api/abonos/listarTiposDeAbonos", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listAbonos = response.data.data.dados;
          // th.showSwal('auto-close', 'Sucesso', 'Usuario cadastrado com sucesso!', 'success')
          // th.tableData = response.data.data.dados
          // th.tableData = response.data.data.dados
          // th.carregarFuse()
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },

    validarDados() {
      let status = true;

      if (this.abono.data_inicial && this.abono.data_inicial !== "") {
        this.erros.data_inicial = false;
      } else {
        this.erros.data_inicial = true;
        status = false;
      }

      if (this.abono.data_final && this.abono.data_final !== "") {
        this.erros.data_final = false;
      } else {
        this.erros.data_final = true;
        status = false;
      }

      if (this.abono.hora && this.abono.hora !== "") {
        this.erros.hora = false;
      } else {
        this.erros.hora = true;
        status = false;
      }

      if (this.abono.tipo) {
        this.erros.tipo = false;
      } else {
        this.erros.tipo = true;
        status = false;
      }

      if (this.abono.file && this.abono.file !== "") {
        this.erros.file = false;
      } else {
        this.erros.file = true;
        status = false;
      }

      return status;
    },

    enviarAbono() {
      const th = this;

      if (this.validarDados()) {
        this.isLoading = true;
        const formData = {
          setDB: this.dados.DB_NAME,
          id_funcionario: this.dados.ID_EMPREGADO,
          id_tipo_abono: this.abono.tipo,
          data_inicial: this.moment(this.abono.data_inicial).format(
            "YYYY-MM-DD",
          ),
          data_final: this.moment(this.abono.data_final).format("YYYY-MM-DD"),
          horas: this.abono.hora ? this.abono.hora + `:00` : "",
          arquivo: this.abono.file,
          status_abono: "A", //aguardando
          modo_abono: 1,
          matricula: this.abono.matricula || null,
        };

        this.axios
          .post("/api/abonos/inserirAbonosFuncionario", formData)
          .then((response) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Abono inserido com sucesso!",
              "success",
            );
            setTimeout(() => {
              th.$router.push("/abono");
            }, 2000);
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao enviar solicitação!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Você precisa preencher todos os campos",
          "error",
        );
      }
    },
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}

.icon_alert {
  color: red;
  margin-right: 5px;
}

.alert-box {
  justify-content: center;
  padding: 15px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  border-radius: 5px;
  text-align: left;
  font-size: 12px;
  max-width: 400px;
}
</style>
